<script>
    export let resource;

    let windowWidth = 0;

    $: linkProps = {
        href: resource.url,
        target: resource.type !== "internalLink" ? "_blank" : undefined,
    };
</script>

<svelte:window bind:innerWidth={windowWidth} />

<a href={linkProps.href} {...linkProps} class="image">
    {#if resource.thumbUrl && windowWidth >= 600}
        <img src={resource.thumbUrl} alt="" loading="lazy" />
    {/if}
</a>
<div class="content">
    <a href={linkProps.href} {...linkProps}>
        <h4 class="title">{resource.title || ""}</h4>
        <p class="description">{resource.description || ""}</p>
    </a>
    {#if window.location.hostname === "localhost"}
        <p class="categories">
            <i><b>Tags: </b>{resource.tags.join(", ")}</i>
        </p>
        <p class="tags" />
        <p class="tags" />
    {/if}
    <p class="link">
        <a
            href={linkProps.href}
            {...linkProps}
            class={`button ${resource.type}`}
        >
            <span class="icon">
                {#if resource.type === "externalLink"}
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="h-5 w-5"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                        ><path
                            d="M11 3a1 1 0 1 0 0 2h2.586l-6.293 6.293a1 1 0 1 0 1.414 1.414L15 6.414V9a1 1 0 1 0 2 0V4a1 1 0 0 0-1-1h-5z"
                        /><path
                            d="M5 5a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2v-3a1 1 0 1 0-2 0v3H5V7h3a1 1 0 0 0 0-2H5z"
                        /></svg
                    >
                {:else if resource.type === "download"}
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="h-5 w-5"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                        ><path
                            fill-rule="evenodd"
                            d="M3 17a1 1 0 0 1 1-1h12a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1zm3.293-7.707a1 1 0 0 1 1.414 0L9 10.586V3a1 1 0 1 1 2 0v7.586l1.293-1.293a1 1 0 1 1 1.414 1.414l-3 3a1 1 0 0 1-1.414 0l-3-3a1 1 0 0 1 0-1.414z"
                            clip-rule="evenodd"
                        /></svg
                    >
                {:else}
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="h-5 w-5"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                    >
                        <path
                            fill-rule="evenodd"
                            d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z"
                            clip-rule="evenodd"
                        />
                    </svg>
                {/if}
            </span>
            {resource.linkLabel}
        </a>
    </p>
</div>
